export default "__VITE_ASSET__DZQRGhEt__"